const imageArray = [
  "/assets/before-after/Anointed 600.png",
  "/assets/before-after/BackWaves 600c.png",
  "/assets/before-after/before-after-1.png",
  "/assets/before-after/BMF 600.png",
  "/assets/before-after/Boot Heart 600.png",
  "/assets/before-after/Buddha 600.png",
  "/assets/before-after/Cartoon 600.png",
  "/assets/before-after/Cherry Blossom 600.png",
  "/assets/before-after/Cindy 600.png",
  "/assets/before-after/Evolve Tattoo Removal_01 Astanza.png",
  "/assets/before-after/Evolve Tattoo Removal_03 Astanza.png",
  "/assets/before-after/Evolve Tattoo Removal_04 Astanza.png",
  "/assets/before-after/GhoulChild 600.png",
  "/assets/before-after/Hey You 600.png",
  "/assets/before-after/InkAway Laser Tattoo Removal B&A.png",
  "/assets/before-after/Jean 600.png",
  "/assets/before-after/Joshua 600.png",
  "/assets/before-after/Jusod 600c.png",
  "/assets/before-after/Kiss 600c.png",
  "/assets/before-after/Letter N 600.png",
  "/assets/before-after/Letter S 600.png",
  "/assets/before-after/Life 600c.png",
  "/assets/before-after/LowBack Shading 600.png",
  "/assets/before-after/Mary 600.png",
  "/assets/before-after/Moons 600c.png",
  "/assets/before-after/Na Shae 600c.png",
  "/assets/before-after/No Regerts LTR B&A.png",
  "/assets/before-after/Northeast Tattoo Removal B&A-02.png",
  "/assets/before-after/Northeast Tattoo Removal B&A.png",
  "/assets/before-after/Pirate Girl 600.png",
  "/assets/before-after/Salinas-Revitalessence.png",
  "/assets/before-after/Skull Neck 600.png",
  "/assets/before-after/SMM 600c.png",
  "/assets/before-after/Spectrum Laser Aesthetics B&A-01.png",
  "/assets/before-after/Spider Web 600c.png",
  "/assets/before-after/Star 600c.png",
  "/assets/before-after/Sun 600c.png",
  "/assets/before-after/Tattoo Removal Ink B&A-01.png",
  "/assets/before-after/Tattoo Removal Ink-01.png",
  "/assets/before-after/Tattoo Removal Ink-02.png"
];

export default imageArray;
